import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { AllAnalogues, DrugItem } from 'src/api/types';
import cn from 'classnames';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import { getAnalyticPreparedDrugList } from 'src/hooks/useAnalytics/useAnalytics.helpers';
import { ItemListName } from 'src/api/analytic.types';
import trns from '../../trns';
import DrugsCarouselContainer from '../../../../shared-components/TopDrugs/DrugsCarouselContainer';

interface Props {
  drug?: DrugItem;
  thirdCategoryName?: string;
  analoguesList: AllAnalogues | null;
  tradeName?: string;
  className?: string;
}

const AnalogueTabContent: FC<Props> = ({
  analoguesList,
  className,
  tradeName
}) => {
  const analoguesGroups = [
    {
      id: 'fullAnalogue',
      title: tradeName ? (
        <FormattedMessage
          values={{ tradeName }}
          {...trns.fullTradeNameAnalogue}
        />
      ) : (
        <FormattedMessage {...trns.fullAnalogue} />
      ),
      description: <FormattedMessage {...trns.fullAnalogueDesc} />
    },
    {
      id: 'sameEffectFormAnalogue',
      title: tradeName ? (
        <FormattedMessage
          values={{ tradeName }}
          {...trns.sameEffectFormTradeNameAnalogue}
        />
      ) : (
        <FormattedMessage {...trns.sameEffectFormAnalogue} />
      ),
      description: <FormattedMessage {...trns.sameEffectFormAnalogueDesc} />
    },

    {
      id: 'otherFormAnalogue',
      title: tradeName ? (
        <FormattedMessage
          values={{ tradeName }}
          {...trns.otherFormTradeNameAnalogue}
        />
      ) : (
        <FormattedMessage {...trns.otherFormAnalogue} />
      ),
      description: ''
    }
  ];

  const gtagPrefixMap = {
    fullAnalogue: GTAGPrefix.fullanalog,
    otherFormAnalogue: GTAGPrefix.otherforms,
    sameEffectFormAnalogue: GTAGPrefix.sameeffect
  };

  const itemListNameMap = {
    fullAnalogue: ItemListName.FullAnalogues,
    otherFormAnalogue: ItemListName.AnaloguesInOtherForms,
    sameEffectFormAnalogue: ItemListName.TherapeuticEffect
  };

  return (
    <div className={cn('flex flex-col lm:mx-0 mx-4', className)}>
      {analoguesList &&
        analoguesGroups
          .filter((group) => analoguesList[group.id]?.length)
          .map((group) => {
            return (
              <div key={group.id}>
                <DrugsCarouselContainer
                  drugsList={getAnalyticPreparedDrugList({
                    drugs: analoguesList[group.id],
                    itemListName: itemListNameMap[group.id]
                  })}
                  isLoading={false}
                  gtagPrefix={gtagPrefixMap[group.id] || GTAGPrefix.default}
                  customLabel={
                    <h3 className="uppercase w-full text-darkBlue fs-header6-bold text-center sm:pt-[63px]">
                      {group.title}
                    </h3>
                  }
                />
              </div>
            );
          })}
    </div>
  );
};

export default AnalogueTabContent;
